// src/store/rolesSlice.js
import { createSlice } from "@reduxjs/toolkit";

const portalInfoSlice = createSlice({
  name: "portalInfo",
  initialState: {},

});

export const portalInfoReducer = portalInfoSlice.reducer;
